export default __webpack_public_path__ + "6a58fcd32a7527f3f8fb7893069c9efb.png";